import {Role} from '../core/auth/user';
import {Dienst} from '../dienst/dienst';
import moment from 'moment';

const dateFormat = 'DD-MM-YYYY';

export class ExtendedActiviteitCijfer {

  static deserialize(dto: ExtendedActiviteitCijferDto): ExtendedActiviteitCijfer {
    return new ExtendedActiviteitCijfer(
      dto.id,
      dto.auteurId,
      dto.auteurNummer,
      dto.auteurNaam,
      dto.auteurRol,
      dto.activiteitType,
      dto.soort,
      new Date(dto.creatieTijdstip),
      new Date(dto.laatstGewijzigdeTijdstip),
      dto.clientId,
      dto.clientNummer,
      dto.clientNaam,
      dto.clientZone,
      dto.dienstId,
    );
  }

  constructor(private id: string,
              private auteurId: string,
              private auteurNummer: string,
              private auteurNaam: string,
              private auteurRol: Role,
              private activiteitType: ActiviteitCijferType,
              private soort: string,
              private creatieTijdstip: Date,
              private laatstGewijzigdeTijdstip: Date,
              private clientId?: string,
              private clientNummer?: string,
              private clientNaam?: string,
              private clientZone?: string,
              private dienstId?: string,
  ) {
  }

  getDienstId(): string {
    return this.dienstId;
  }

  toActiviteitCijfer(dienst: Dienst | undefined): ActiviteitCijfer {
    return new ActiviteitCijfer(
      this.auteurNummer,
      this.auteurNaam,
      this.auteurRol,
      this.activiteitType,
      this.soort,
      moment(this.creatieTijdstip).format(dateFormat),
      moment(this.laatstGewijzigdeTijdstip).format(dateFormat),
      dienst?.getLabel(),
      this.clientNummer,
      this.clientNaam,
      this.clientZone,
    );
  }
}

export class ActiviteitCijfer {
  constructor(
    private medewerkernummer: string,
    private medewerker: string,
    private medewerkerfunctie: string,
    private type: string,
    private soort: string,
    private creatiedatum: string,
    private laatstgewijzigdedatum: string,
    private dienst?: string,
    private clientnummer?: string,
    private clientnaam?: string,
    private clientregio?: string,
  ) {
  }
}

export interface ExtendedActiviteitCijferDto {
  id: string,
  auteurId: string,
  auteurNummer: string,
  auteurNaam: string,
  auteurRol: Role,
  activiteitType: ActiviteitCijferType,
  soort: string,
  creatieTijdstip: string,
  laatstGewijzigdeTijdstip: string,
  clientId?: string,
  clientNummer?: string,
  clientNaam?: string,
  clientZone?: string,
  dienstId?: string,
}

export enum ActiviteitCijferType {
  SIGNAALKAART = 'Signaalkaart',
  MELDING = 'Melding',
  TIP = 'Tip',
}
